
// export const SERVER_HOST = 'http://192.168.2.173:8082';
// export const SERVER_HOST = 'http://qjgl.cn1.utools.club';
export const SERVER_HOST = '/api';
